import { Button } from "@/components/ui/button";
import { Wrench, ShoppingCart } from "lucide-react";
import { fmtQty } from "@/lib/constants";

// Admin-only: spare parts at/below reorder level (or out of stock) — order before a line goes down waiting on one.
export default function SpareReorderBanner({ items, onOpenPurchase }) {
  const low = (items || []).filter((i) => i.item_type === "spare" && !i.archived && ((i.min_stock ?? 0) > 0 ? (i.stock_quantity ?? 0) <= i.min_stock : (i.stock_quantity ?? 0) <= 0));
  if (low.length === 0) return null;
  const out = low.filter((i) => (i.stock_quantity ?? 0) <= 0).length;
  return (
    <div className="rounded-xl border border-orange-300 bg-orange-50 px-4 py-3.5 flex items-start gap-3" data-testid="spare-reorder-banner">
      <Wrench className="h-5 w-5 text-orange-600 mt-0.5 shrink-0" />
      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold text-orange-900" data-testid="spare-reorder-title">
          Reorder Brought Out parts — {low.length} item{low.length > 1 ? "s" : ""} at reorder level{out > 0 ? ` · ${out} out of stock` : ""}
        </p>
        <div className="mt-1.5 flex flex-wrap gap-1.5" data-testid="spare-reorder-list">
          {low.map((i) => (
            <span key={i.sku} className={`inline-flex items-center gap-1 rounded-md bg-white border px-2 py-0.5 text-[11px] font-mono-data ${(i.stock_quantity ?? 0) <= 0 ? "border-red-300 text-red-800" : "border-orange-200 text-orange-800"}`} data-testid={`spare-reorder-chip-${i.sku}`}>
              <span className="font-semibold">{i.name}</span>
              <span className="opacity-70">{fmtQty(i.stock_quantity ?? 0, i.unit)}/{fmtQty(i.min_stock ?? 0, i.unit)} {i.unit}</span>
            </span>
          ))}
        </div>
      </div>
      {onOpenPurchase && (
        <Button size="sm" className="h-8 text-xs bg-orange-600 hover:bg-orange-700 shrink-0" onClick={onOpenPurchase} data-testid="spare-reorder-btn">
          <ShoppingCart className="h-3.5 w-3.5 mr-1" /> Reorder
        </Button>
      )}
    </div>
  );
}
